import axios, {AxiosRequestConfig, AxiosResponse} from "axios";
import {BASE_URL, TOKEN, TOKEN_ADMIN} from "constants/config";

const axiosClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  transformRequest: [
    (data, headers) => {
      if (data && typeof data === "object" && !(data instanceof FormData)) {
        if (headers) {
          headers["Content-Type"] = "application/json";
        }
        return JSON.stringify(data);
      }
      return data;
    },
  ],
});

// Add a request interceptor
axiosClient.interceptors.request.use(
  function (config: AxiosRequestConfig) {
    const token = localStorage.getItem(TOKEN_ADMIN) || localStorage.getItem(TOKEN);
    config.headers.Authorization = token ? `Bearer ${token}` : "";
    if (config.data && !(config.data instanceof FormData)) {
      config.headers["Content-Type"] = "application/json";
    }
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosClient.interceptors.response.use(
  function (response: AxiosResponse) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response.data;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  }
);

export default axiosClient;
